export default __webpack_public_path__ + "static/media/translate.fc188a59.svg";